import { Action } from 'redux';

export const GET_ALL_PERMISSIONS_GROUPS = 'general-settings/GET_ALL_PERMISSIONS_GROUPS';
export const SET_ALL_PERMISSIONS_GROUPS = 'general-settings/SET_ALL_PERMISSIONS_GROUPS';
export const SET_PERMISSION_ROLES = 'general-settings/SET_PERMISSION_ROLES';
export const GET_PERMISSION_ROLES = 'general-settings/GET_PERMISSION_ROLES';
export const CREATE_PERMISSION_GROUP = 'general-settings/CREATE_PERMISSION_GROUP';
export const SET_SELECTED_PERMISSION_GROUP = 'general-settings/SET_SELECTED_PERMISSION_GROUP';
export const SET_SELECTED_PERMISSION_GROUP_COMPLETE = 'general-settings/SET_SELECTED_PERMISSION_GROUP_COMPLETE';
export const SET_EDIT_PERMISSION_MODE_YN = 'general-settings/SET_EDIT_PERMISSION_MODE_YN';
export const SET_EDIT_PERMISSION_MODE_YN_COMPLETE = 'general-settings/SET_EDIT_PERMISSION_MODE_YN_COMPLETE';
export const OPEN_PERMISSION_MODAL = 'general-settings/OPEN_PERMISSION_MODAL';
export const OPEN_PERMISSION_MODAL_COMPLETE = 'general-settings/OPEN_PERMISSION_MODAL_COMPLETE';
export const UPDATE_PERMISSION_GROUP = 'general-settings/UPDATE_PERMISSION_GROUP';
export const GET_GENERAL_SETTINGS_USERS = 'general-settings/GET_GENERAL_SETTINGS_USERS';
export const SET_GENERAL_SETTINGS_USERS = 'general-settings/SET_GENERAL_SETTINGS_USERS';
export const DELETE_PERMISSION_GROUP = 'general-settings/DELETE_PERMISSION_GROUP';
export const PERMISSION_OPTION_MODAL = 'general-settings/PERMISSION_OPTION_MODAL';
export const PERMISSION_OPTION_MODAL_COMPLETE = 'general-settings/PERMISSION_OPTION_MODAL_COMPLETE';
export const PERMISSION_DELETE_MODAL = 'general-settings/PERMISSION_DELETE_MODAL';
export const PERMISSION_DELETE_MODAL_COMPLETE = 'general-settings/PERMISSION_DELETE_MODAL_COMPLETE';

export const SET_EDIT_USER_MODE_YN = 'general-settings/SET_EDIT_USER_MODE_YN';
export const SET_EDIT_USER_MODE_YN_COMPLETE = 'general-settings/SET_EDIT_USER_MODE_YN_COMPLETE';
export const OPEN_USER_MODAL = 'general-settings/OPEN_USER_MODAL';
export const OPEN_USER_MODAL_COMPLETE = 'general-settings/OPEN_USER_MODAL_COMPLETE';
export const CREATE_GENERAL_SETTINGS_USER = 'general-sttings/CREATE_GENERAL_SETTINGS_USER';
export const SET_SELECTED_USER = 'general-settings/SET_SELECTED_USER';
export const SET_SELECTED_USER_COMPLETE = 'general-settings/SET_SELECTED_USER_COMPLETE';
export const UPDATE_GENERAL_SETTINGS_USER = 'general-settings/UPDATE_GENERAL_SETTINGS_USER';
export const DELETE_GENERAL_SETTINGS_USER = 'general-settings/DELETE_GENERAL_SETTINGS_USER';

export const DISABLE_GENERAL_SETTINGS_USER = 'general-settings/DISABLE_GENERAL_SETTINGS_USER';
export const ENABLE_GENERAL_SETTINGS_USER = 'general-settings/ENABLE_GENERAL_SETTINGS_USER';
export const OPEN_DISABLE_MODAL_YN = 'general-settings/OPEN_DISABLE_MODAL_YN';
export const OPEN_ACTIVE_MODAL_YN = 'general-settings/OPEN_ACTIVE_MODAL_YN';
export const SHOW_ACTIVATE_MODAL_YN = 'general-settings/SHOW_ACTIVATE_MODAL_YN';
export const HIDE_ACTIVATE_MODAL_YN = 'general-settings/HIDE_ACTIVATE_MODAL_YN';

export const OPEN_DISABLE_MODAL_YN_COMPLETE = 'general-settings/OPEN_DISABLE_MODAL_YN_COMPLETE';
export const OPEN_ENABLE_MODAL_YN_COMPLETE = 'general-settings/OPEN_ENABLE_MODAL_YN_COMPLETE';
export const OPEN_USER_OPTION_MODAL_YN = 'general-settings/OPEN_USER_OPTION_MODAL_YN';
export const OPEN_USER_OPTION_MODAL_YN_COMPLETE = 'general-settings/OPEN_USER_OPTION_MODAL_YN_COMPLETE';
export const OPEN_USER_DELETE_MODAL_YN = 'general-settings/OPEN_USER_DELETE_MODAL_YN';
export const OPEN_USER_DELETE_MODAL_YN_COMPLETE = 'general-settings/OPEN_USER_DELETE_MODAL_YN_COMPLETE';

export const EXPORT_USER_XLSX = 'general-settings/EXPORT_USER_XLSX';
export const EXPORT_USER_CSV = 'general-settings/EXPORT_USER_CSV';

export const PERMIT_SEND_EMAIL = 'general-settings/PERMIT_SEND_EMAIL';
export const EXPORT_PERMISSION_XLSX = 'general-settings/EXPORT_PERMISSION_XLSX';
export const EXPORT_PERMISSION_CSV = 'general-settings/EXPORT_PERMISSION_CSV';
export const SMTP_FORM_MODAL_YN = 'general-settings/SMTP_FORM_MODAL_YN';
export const SMTP_EMAIL_FORM_YN = 'general-settings/SMTP_EMAIL_FORM_YN';
export const SMTP_UPDATE = 'general-settings/SMTP_UPDATE';
export const GET_SMTP = 'general-settings/GET_SMTP';
export const SET_SMTP = 'general-settings/SET_SMTP';
export const SEND_EMAIL_TESTING = 'general-settings/SEND_TEST_EMAIL_TESTING';

export const sendEmailTesting = (data: SMTPEmailPayload) => {
  return {
    type: SEND_EMAIL_TESTING,
    payload: data,
  };
};

export const setSmtp = (data: SMTPEmailSettingsFormValuesT) => {
  return {
    type: SET_SMTP,
    payload: data,
  };
};

export const getSmtp = () => {
  return {
    type: GET_SMTP,
  };
};

export const smtpUpdate = (data: SMTPEmailSettingsFormValuesT) => {
  return {
    type: SMTP_UPDATE,
    payload: data,
  };
};

export const smtpFormModalYN = (data: boolean) => {
  return {
    type: SMTP_FORM_MODAL_YN,
    payload: data,
  };
};

export const smtpEmailFormModalYN = (data: boolean) => {
  return {
    type: SMTP_EMAIL_FORM_YN,
    payload: data,
  };
};

export const openUserDeleteModalYN = (data: boolean) => {
  return {
    type: OPEN_USER_DELETE_MODAL_YN,
    payload: data,
  };
};

export const openUserDeleteModalYNComplete = (data: boolean) => {
  return {
    type: OPEN_USER_DELETE_MODAL_YN_COMPLETE,
    payload: data,
  };
};

export const openUserOptionModalYN = (data: boolean) => {
  return {
    type: OPEN_USER_OPTION_MODAL_YN,
    payload: data,
  };
};
export const openUserOptionModalYNComplete = (data: boolean) => {
  return {
    type: OPEN_USER_OPTION_MODAL_YN_COMPLETE,
    payload: data,
  };
};

export const openDisableModalYN = (data: boolean) => {
  return {
    type: OPEN_DISABLE_MODAL_YN,
    payload: data,
  };
};
// open active user modal
export const openActiveModalYN = (data: boolean) => {
  return {
    type: OPEN_ACTIVE_MODAL_YN,
    payload: data,
  };
};
// show activate user
export const showActivateUserModal = () => {
  return {
    type: SHOW_ACTIVATE_MODAL_YN,
  };
};
export const hideActivateUserModal = () => {
  return {
    type: HIDE_ACTIVATE_MODAL_YN,
  };
};
export const openDisableModalYNComplete = (data: boolean) => {
  return {
    type: OPEN_DISABLE_MODAL_YN_COMPLETE,
    payload: data,
  };
};
export const openEnableModalYNComplete = (data: boolean) => {
  return {
    type: OPEN_ENABLE_MODAL_YN_COMPLETE,
    payload: data,
  };
};
export const setPermissionModalYN = (data: boolean) => {
  return {
    type: PERMISSION_OPTION_MODAL,
    payload: data,
  };
};
export const setPermissionModalYNComplete = (data: boolean) => {
  return {
    type: PERMISSION_OPTION_MODAL_COMPLETE,
    payload: data,
  };
};
export const setPermissionDeleteModalYN = (data: boolean) => {
  return {
    type: PERMISSION_DELETE_MODAL,
    payload: data,
  };
};
export const setPermissionDeleteModalYNComplete = (data: boolean) => {
  return {
    type: PERMISSION_DELETE_MODAL_COMPLETE,
    payload: data,
  };
};

export const getAllPermissionsGroup = () => {
  return {
    type: GET_ALL_PERMISSIONS_GROUPS,
  };
};
export const setAllPermissionsGroup = (data: any) => {
  return {
    type: SET_ALL_PERMISSIONS_GROUPS,
    payload: data,
  };
};

export const setPermissionRoles = (data: any) => {
  return {
    type: SET_PERMISSION_ROLES,
    payload: data,
  };
};

export const getPermissionRoles = () => {
  return {
    type: GET_PERMISSION_ROLES,
  };
};
export const createPermissionGroup = (data: any) => {
  return {
    type: CREATE_PERMISSION_GROUP,
    payload: data,
  };
};
export const setSelectedPermissionGroup = (data: any) => {
  return {
    type: SET_SELECTED_PERMISSION_GROUP,
    payload: data,
  };
};
export const setSelectedPermissionGroupComplete = (data: any) => {
  return {
    type: SET_SELECTED_PERMISSION_GROUP_COMPLETE,
    payload: data,
  };
};

export const setSelectedGeneralSettingsUser = (data: any) => {
  return {
    type: SET_SELECTED_USER,
    payload: data,
  };
};
export const setSelectedGeneralSettingsUserComplete = (data: any) => {
  return {
    type: SET_SELECTED_USER_COMPLETE,
    payload: data,
  };
};

export const setEditPermissionModeYN = (data: boolean) => {
  return {
    type: SET_EDIT_PERMISSION_MODE_YN,
    payload: data,
  };
};
export const setEditPermissionModeYNComplete = (data: boolean) => {
  return {
    type: SET_EDIT_PERMISSION_MODE_YN_COMPLETE,
    payload: data,
  };
};
export const setEditUserModeYN = (data: boolean) => {
  return {
    type: SET_EDIT_USER_MODE_YN,
    payload: data,
  };
};
export const setEditUserModeYNComplete = (data: boolean) => {
  return {
    type: SET_EDIT_USER_MODE_YN_COMPLETE,
    payload: data,
  };
};
export const openPermissionModal = (data: boolean) => {
  return {
    type: OPEN_PERMISSION_MODAL,
    payload: data,
  };
};
export const openPermissionModalComplete = (data: boolean) => {
  return {
    type: OPEN_PERMISSION_MODAL_COMPLETE,
    payload: data,
  };
};
export const openUserModal = (data: boolean) => {
  return {
    type: OPEN_USER_MODAL,
    payload: data,
  };
};
export const openUserModalComplete = (data: boolean) => {
  return {
    type: OPEN_USER_MODAL_COMPLETE,
    payload: data,
  };
};

export const updatePermissionGroup = (data: any) => {
  return {
    type: UPDATE_PERMISSION_GROUP,
    payload: data,
  };
};
export const getGeneralSettingsUsers = () => {
  return {
    type: GET_GENERAL_SETTINGS_USERS,
  };
};

export const setGeneralSettingsUsers = (data: any) => {
  return {
    type: SET_GENERAL_SETTINGS_USERS,
    payload: data,
  };
};
export const createGeneralSettiongsUser = (data: any) => {
  return {
    type: CREATE_GENERAL_SETTINGS_USER,
    payload: data,
  };
};
export const updateGeneralSettingsUser = (data: any) => {
  return {
    type: UPDATE_GENERAL_SETTINGS_USER,
    payload: data,
  };
};
export const deleteGeneralSettingsUser = (data: any) => {
  return {
    type: DELETE_GENERAL_SETTINGS_USER,
    payload: data,
  };
};

export const deletePermissionGroups = (data: any) => {
  return {
    type: DELETE_PERMISSION_GROUP,
    payload: data,
  };
};
export const disableGeneralSettingsUser = (data: any) => {
  return {
    type: DISABLE_GENERAL_SETTINGS_USER,
    payload: data,
  };
};
export const enableGeneralSettingsUser = (data: any) => {
  return {
    type: ENABLE_GENERAL_SETTINGS_USER,
    payload: data,
  };
};
export const exportUserXLSX = (data: any) => {
  return {
    type: EXPORT_USER_XLSX,
    payload: data,
  };
};

export const exportUserCSV = (data: any) => {
  return {
    type: EXPORT_USER_CSV,
    payload: data,
  };
};
export const sendPermitMail = (data: any) => {
  return {
    type: PERMIT_SEND_EMAIL,
    payload: data,
  };
};

export const exportPermissionCSV = (data: any) => {
  return {
    type: EXPORT_PERMISSION_CSV,
    payload: data,
  };
};
export const exportPermissionXLSX = (data: any) => {
  return {
    type: EXPORT_PERMISSION_XLSX,
    payload: data,
  };
};

export interface ShowActivateUserModalAction extends Action<typeof SHOW_ACTIVATE_MODAL_YN> {}
export interface HideActivateUserModalAction extends Action<typeof HIDE_ACTIVATE_MODAL_YN> {}

export interface SetAllPermissionsGroupAction extends Action<typeof SET_ALL_PERMISSIONS_GROUPS> {
  readonly payload: any;
}

export interface SetPermissionRolesAction extends Action<typeof SET_PERMISSION_ROLES> {
  readonly payload: any;
}

export interface SetSelectedPermissionAction extends Action<typeof SET_SELECTED_PERMISSION_GROUP_COMPLETE> {
  readonly payload: any;
}
export interface SetEditPermissionAction extends Action<typeof SET_EDIT_PERMISSION_MODE_YN_COMPLETE> {
  readonly payload: boolean;
}
export interface SetOpenPermissionModalAction extends Action<typeof OPEN_PERMISSION_MODAL_COMPLETE> {
  readonly payload: boolean;
}

export interface SetGeneralSettingsUsersAction extends Action<typeof SET_GENERAL_SETTINGS_USERS> {
  readonly payload: any;
}

export interface SetEditUserAction extends Action<typeof SET_EDIT_USER_MODE_YN_COMPLETE> {
  readonly payload: boolean;
}
export interface SetOpenUserModalAction extends Action<typeof OPEN_USER_MODAL_COMPLETE> {
  readonly payload: boolean;
}
export interface SetSelectedGeneralSettingsUsersAction extends Action<typeof SET_SELECTED_USER_COMPLETE> {
  readonly payload: any;
}

export interface SetPermissionOptionModalAction extends Action<typeof PERMISSION_OPTION_MODAL_COMPLETE> {
  readonly payload: boolean;
}

export interface SetPermissionDeleteModalAction extends Action<typeof PERMISSION_DELETE_MODAL_COMPLETE> {
  readonly payload: boolean;
}

export interface SetDisableModalAction extends Action<typeof OPEN_DISABLE_MODAL_YN_COMPLETE> {
  readonly payload: boolean;
}
export interface SetEnableModalAction extends Action<typeof OPEN_ENABLE_MODAL_YN_COMPLETE> {
  readonly payload: boolean;
}

export interface SetUserOptionModalAction extends Action<typeof OPEN_USER_OPTION_MODAL_YN_COMPLETE> {
  readonly payload: boolean;
}

export interface SetUserDeleteModalAction extends Action<typeof OPEN_USER_DELETE_MODAL_YN_COMPLETE> {
  readonly payload: boolean;
}

export interface SMTPFormModalAction extends Action<typeof SMTP_FORM_MODAL_YN> {
  readonly payload: boolean;
}
export interface SMTPEmailFormModalAction extends Action<typeof SMTP_EMAIL_FORM_YN> {
  readonly payload: boolean;
}
export interface SMTPAction extends Action<typeof SET_SMTP> {
  readonly payload: SMTPEmailSettingsFormValuesT;
}

export type ClientAdminGeneralSettingAction =
  | SetAllPermissionsGroupAction
  | SetPermissionRolesAction
  | SetSelectedPermissionAction
  | SetEditPermissionAction
  | SetOpenPermissionModalAction
  | SetGeneralSettingsUsersAction
  | SetEditUserAction
  | SetOpenUserModalAction
  | SetSelectedGeneralSettingsUsersAction
  | SetPermissionOptionModalAction
  | SetPermissionDeleteModalAction
  | SetDisableModalAction
  | SetUserOptionModalAction
  | SetUserDeleteModalAction
  | SMTPFormModalAction
  | SMTPEmailFormModalAction
  | SMTPAction
  | SetEnableModalAction
  | ShowActivateUserModalAction
  | HideActivateUserModalAction;
